// src/lib/notificationSound.js
// Reproduce un MP3 al recibir push en foreground.
// - El asset vive en /public/sounds/notification.mp3 → URL pública /sounds/notification.mp3
// - Pre-carga el Audio una vez (singleton) para evitar latencia
// - "Desbloquea" el audio al primer touch/click (mobile bloquea autoplay)
// - Si el browser bloquea (permiso denegado, AbortError), no rompe nada

const SOUND_URL = '/sounds/notification.mp3'

let audioEl = null
let unlocked = false

function getAudio() {
  if (audioEl) return audioEl
  if (typeof Audio === 'undefined') return null
  audioEl = new Audio(SOUND_URL)
  audioEl.preload = 'auto'
  audioEl.volume = 0.8
  return audioEl
}

export function playNotificationSound(urgent = false) {
  const a = getAudio()
  if (!a) return
  try {
    // Reset al principio por si suena dos veces seguidas
    a.currentTime = 0
    a.volume = urgent ? 1.0 : 0.8
    const p = a.play()
    if (p && typeof p.catch === 'function') {
      p.catch((err) => {
        // NotAllowedError típico de mobile sin interacción. Falla silenciosa.
        console.warn('[notif sound] play bloqueado:', err.name || err)
      })
    }
  } catch (err) {
    console.warn('[notif sound] error inesperado:', err)
  }
}

// Listener del SW: cuando el SW emite BELLASON_PUSH_SOUND, suena el tono en
// foreground (el push real ya suena en background vía notificación del browser).
export function attachServiceWorkerSoundListener() {
  if (!('serviceWorker' in navigator)) return
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'BELLASON_PUSH_SOUND') {
      playNotificationSound(!!event.data.urgent)
    }
  })
}

// En mobile (Chrome/Safari) el navegador bloquea `audio.play()` hasta que el
// usuario interactúa con la página al menos una vez. Esta función registra
// listeners one-shot que reproducen el sonido en silencio (volumen 0) al
// primer touch, desbloqueándolo para llamadas posteriores con volumen normal.
export function unlockAudioOnFirstInteraction() {
  if (unlocked) return
  const unlock = () => {
    if (unlocked) return
    const a = getAudio()
    if (a) {
      const prevVol = a.volume
      a.volume = 0
      const p = a.play()
      const done = () => {
        a.pause()
        a.currentTime = 0
        a.volume = prevVol
        unlocked = true
      }
      if (p && typeof p.then === 'function') {
        p.then(done).catch(() => { unlocked = true })
      } else {
        done()
      }
    }
    document.removeEventListener('pointerdown', unlock)
    document.removeEventListener('touchstart', unlock)
    document.removeEventListener('keydown', unlock)
  }
  document.addEventListener('pointerdown', unlock, { once: true })
  document.addEventListener('touchstart', unlock, { once: true })
  document.addEventListener('keydown', unlock, { once: true })
}
